export default __webpack_public_path__ + "static/selfie-448b9e4e96bb03ef2ac1826e61d8363c.jpeg";